import { render } from "./location.vue?vue&type=template&id=6bc81ce4&scoped=true"
import script from "./location.vue?vue&type=script&lang=js"
export * from "./location.vue?vue&type=script&lang=js"

import "./location.vue?vue&type=style&index=0&id=6bc81ce4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6bc81ce4"

export default script